import { useClipboard } from "use-clipboard-copy";
// https://github.com/wsmd/use-clipboard-copy
export default useClipboard;
